import React from "react";
import { Outlet } from "react-router-dom";

const DndCombatTracker: React.FunctionComponent = () => <Outlet />;

export default DndCombatTracker;
